import { init } from "../init";
import { ConfluenceSoftwarePage } from "../pages/confluence/confluence-software-page";
init(ConfluenceSoftwarePage);
